import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=4b29d817&scoped=true&"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=4b29d817&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29d817",
  null
  
)

export default component.exports